import { CustomerEntryName } from '../../utils/step-engine-constants';

export const SET_CURRENT_STEP = 'stepEngine/SET_CURRENT_STEP';
export const ADD_PREVIOUS_STEP = 'stepEngine/ADD_PREVIOUS_STEP';
export const REMOVE_PREVIOUS_STEP = 'stepEngine/REMOVE_PREVIOUS_STEP';
export const SET_STEP_ENGINE_SUBSCRIPTION = 'stepEngine/SET_STEP_ENGINE_SUBSCRIPTION';
export const SET_STEP_ENGINE_SUBSCRIBER = 'stepEngine/SET_STEP_ENGINE_SUBSCRIBER';
export const SET_STEP_ENGINE_CREATED_CLAIM = 'stepEngine/SET_STEP_ENGINE_CREATED_CLAIM';
export const SET_GLOBAL_DATA_CREATED_CLAIM = 'stepEngine/SET_GLOBAL_DATA_CREATED_CLAIM';
export const SET_STEP_ENGINE_CREATED_BENEFIT = 'stepEngine/SET_STEP_ENGINE_CREATED_BENEFIT';
export const SET_COVER = 'stepEngine/SET_COVER';
export const SET_PREVIOUS_COVER = 'stepEngine/SET_PREVIOUS_COVER';
export const REMOVE_PREVIOUS_COVER = 'stepEngine/REMOVE_PREVIOUS_COVER';
export const SET_COVER_DISPLAY_NAME = 'stepEngine/SET_COVER_DISPLAY_NAME';
export const SET_CUSTOMER_ENTRY = 'stepEngine/SET_CUSTOMER_ENTRY';
export const ADD_CUSTOMER_ENTRY = 'stepEngine/ADD_CUSTOMER_ENTRY';
export const REMOVE_CUSTOMER_ENTRY = 'stepEngine/REMOVE_CUSTOMER_ENTRY';
export const ADD_GLOBAL_DATA = 'stepEngine/ADD_GLOBAL_DATA';
export const REMOVE_GLOBAL_DATA = 'stepEngine/REMOVE_GLOBAL_DATA';
export const REMOVE_DECLARATION_GLOBAL_DATA = 'stepEngine/REMOVE_DECLARATION_GLOBAL_DATA';
export const RESET_STEP_ENGINE = 'stepEngine/RESET_STEP_ENGINE';
export const SET_BACK_TO_HOME = 'stepEngine/SET_BACK_TO_HOME';
export const SET_GO_TO_LOGIN_ERROR = 'stepEngine/SET_GO_TO_LOGIN_ERROR';
export const SET_SHOW_ELIGIBILITY_MODAL = 'stepEngine/SET_SHOW_ELIGIBILITY_MODAL';
export const SET_STEP_TO_SCROLL = 'stepEngine/SET_STEP_TO_SCROLL';
export const CLEAR_STEP_TO_SCROLL = 'stepEngine/CLEAR_STEP_TO_SCROLL';
export const SET_SHOW_ERROR_MODAL = 'stepEngine/SET_SHOW_ERROR_MODAL';
export const SET_SHOW_STEP_ACTION = 'stepEngine/SET_SHOW_STEP_ACTION';
export const SET_STEP_GROUP = 'stepEngine/SET_STEP_GROUP';
export const SET_DONT_SHOW_POPUP_REDIRECT_URL = 'stepEngine/SET_DONT_SHOW_POPUP_REDIRECT_URL';
export const SET_ADDITIONAL_STEP = 'stepEngine/SET_ADDITIONAL_STEP';
export const SET_RECEIVED_STEP = 'stepEngine/SET_RECEIVED_STEP';
export const SET_DISABLED_NEXT_BUTTON = 'stepEngine/SET_DISABLED_NEXT_BUTTON';
export const REMOVE_DISABLED_NEXT_BUTTON = 'stepEngine/REMOVE_DISABLED_NEXT_BUTTON';
export const SET_STEP_ENGINE_DEVICE_TYPE = 'stepEngine/SET_STEP_ENGINE_DEVICE_TYPE';
export const SET_SHOW_RATING_MODAL = 'stepEngine/SET_SHOW_RATING_MODAL';
export const SET_LAST_EDIT_STEP = 'stepEngine/SET_EDIT_LAST_STEP';
export const SET_CURRENT_STEP_GROUP = 'stepEngine/SET_CURRENT_STEP_GROUP';
export const SET_STEP_LIST_COMPONENT = 'stepEngine/SET_STEP_LIST_COMPONENT';
export const SET_USE_CASES = 'stepEngine/SET_USE_CASES';

export interface SetRecivedStep {
  type: typeof SET_RECEIVED_STEP;
  payload: string[];
}
export interface SetCurrentStep {
  type: typeof SET_CURRENT_STEP;
  payload: string[];
}

export interface SetCurrentStepGroup {
  type: typeof SET_CURRENT_STEP_GROUP;
  payload: string;
}

export interface SetStepListComponent {
  type: typeof SET_STEP_LIST_COMPONENT;
  payload: { [id: string]: [] };
}

export interface SetLastEditStep {
  type: typeof SET_LAST_EDIT_STEP;
  payload: string;
}

export interface AddPreviousStep {
  type: typeof ADD_PREVIOUS_STEP;
  payload: { sourceSteps: string[]; targetStep: string[] };
}

export interface RemovePreviousStep {
  type: typeof REMOVE_PREVIOUS_STEP;
  payload: { targetStep: string };
}

export interface SetSubscription {
  type: typeof SET_STEP_ENGINE_SUBSCRIPTION;
  payload: any;
}

export interface SetSubscriber {
  type: typeof SET_STEP_ENGINE_SUBSCRIBER;
  payload: any;
}

export interface SetCreatedClaim {
  type: typeof SET_STEP_ENGINE_CREATED_CLAIM;
  payload: any;
}

export interface SetCreatedBenefit {
  type: typeof SET_STEP_ENGINE_CREATED_BENEFIT;
  payload: any;
}

export interface SetGlobalDataCreatedClaim {
  type: typeof SET_GLOBAL_DATA_CREATED_CLAIM;
  payload: any;
}

export interface SetCover {
  type: typeof SET_COVER;
  payload: string;
}

export interface SetPreviousCover {
  type: typeof SET_PREVIOUS_COVER;
  payload: string;
}

export interface RemovePreviousCover {
  type: typeof REMOVE_PREVIOUS_COVER;
}

export interface SetCoverDisplayName {
  type: typeof SET_COVER_DISPLAY_NAME;
  payload: string;
}

export interface SetCustomerEntry {
  type: typeof SET_CUSTOMER_ENTRY;
  payload: { [id: string]: string };
}

export interface AddCustomerEntry {
  type: typeof ADD_CUSTOMER_ENTRY;
  payload: { customerEntryName: CustomerEntryName; value: any };
}

export interface RemoveCustomerEntry {
  type: typeof REMOVE_CUSTOMER_ENTRY;
  payload: { customerEntryName: CustomerEntryName };
}

export interface AddGlobalData {
  type: typeof ADD_GLOBAL_DATA;
  payload: { key: string; value: any };
}

export interface RemoveGlobalData {
  type: typeof REMOVE_GLOBAL_DATA;
  payload: { key: string };
}

export interface RemoveDeclarationGlobalData {
  type: typeof REMOVE_DECLARATION_GLOBAL_DATA;
  payload: { key: string };
}

export interface ResetStepEngine {
  type: typeof RESET_STEP_ENGINE;
}

export interface SetBackToHome {
  type: typeof SET_BACK_TO_HOME;
  payload: boolean;
}

export interface SetGoToLoginError {
  type: typeof SET_GO_TO_LOGIN_ERROR;
  payload: boolean;
}

export interface SetShowEligibilityModal {
  type: typeof SET_SHOW_ELIGIBILITY_MODAL;
  payload: boolean;
}

export interface SetStepToScroll {
  type: typeof SET_STEP_TO_SCROLL;
  payload: string;
}

export interface ClearStepToScroll {
  type: typeof CLEAR_STEP_TO_SCROLL;
}

export interface SetShowErrorModal {
  type: typeof SET_SHOW_ERROR_MODAL;
  payload: boolean;
}

export interface SetShowStepAction {
  type: typeof SET_SHOW_STEP_ACTION;
  payload: boolean;
}

export interface SetStepGroup {
  type: typeof SET_STEP_GROUP;
  payload: string;
}

export interface SetDontShowPopupRedirectUrl {
  type: typeof SET_DONT_SHOW_POPUP_REDIRECT_URL;
  payload: boolean;
}
export interface SetStepEngineDeviceType {
  type: typeof SET_STEP_ENGINE_DEVICE_TYPE;
  payload: string;
}

export interface SetShowRatingModal {
  type: typeof SET_SHOW_RATING_MODAL;
  payload: boolean;
}

export interface SetDisabledNextButton {
  type: typeof SET_DISABLED_NEXT_BUTTON;
  payload: { key: string; value: any };
}

export interface RemoveDisabledNextButton {
  type: typeof REMOVE_DISABLED_NEXT_BUTTON;
  payload: { key: string };
}

export interface SetUseCases {
  type: typeof SET_USE_CASES;
  payload: any;
}

// --- Create Union Type

export type ActionsTypes =
  | SetCurrentStep
  | SetLastEditStep
  | AddPreviousStep
  | RemovePreviousStep
  | SetSubscription
  | SetSubscriber
  | SetCreatedClaim
  | SetCreatedBenefit
  | SetCover
  | SetPreviousCover
  | RemovePreviousCover
  | SetCoverDisplayName
  | SetCustomerEntry
  | AddCustomerEntry
  | RemoveCustomerEntry
  | ResetStepEngine
  | SetBackToHome
  | SetGoToLoginError
  | SetShowEligibilityModal
  | SetStepToScroll
  | ClearStepToScroll
  | SetShowErrorModal
  | AddGlobalData
  | RemoveGlobalData
  | RemoveDeclarationGlobalData
  | SetShowStepAction
  | SetRecivedStep
  | SetDisabledNextButton
  | RemoveDisabledNextButton
  | SetStepGroup
  | SetDontShowPopupRedirectUrl
  | SetStepEngineDeviceType
  | SetShowRatingModal
  | SetCurrentStepGroup
  | SetStepListComponent
  | SetUseCases
  | SetGlobalDataCreatedClaim;
